import React from 'react';

/**
 * Renders stacked label/value lines inside a single table cell.
 * Each line: { label, content, show?, valueStyle?, valueClassName? }
 */
export function CombinedColumnCell({ lines, className = 'orders-column-group-cell text-start' }) {
    const visibleLines = (lines || []).filter((line) => line.show !== false && line.content != null && line.content !== '');
    if (!visibleLines.length) {
        return <span className="text-muted">—</span>;
    }
    return (
        <div className={className}>
            {visibleLines.map((line, index) => (
                <div key={`${line.label}-${index}`} className="orders-column-group-line">
                    {line.label ? (
                        <span className="orders-column-group-label">{line.label}: </span>
                    ) : null}
                    <span
                        className={`orders-column-group-value${line.valueClassName ? ` ${line.valueClassName}` : ''}`}
                        style={line.valueStyle}
                    >
                        {line.content}
                    </span>
                </div>
            ))}
        </div>
    );
}

export default CombinedColumnCell;
